import { selector } from '@/lib/selectors';

import { PaymentProviderStatuses } from '@/domain/paySettings/helpers';
import { isStoreOnAnotherCompany } from '@/domain/documents';
import { paymentProvidersLeafSelector } from '@/domain/paySettings/paySettingsLeafSelectors';

export const paySettings = (state) => state.paySettings;

export const paymentProvidersSelector = paymentProvidersLeafSelector;

export const firstActivePaymentProviderNameSelector = selector(
  paymentProvidersSelector,
  (p) => p.find((item) => item.status === PaymentProviderStatuses.connected)?.providerName,
);

export const connectedPaymentProviderIdSelector = selector(
  paymentProvidersSelector,
  (p) => p.find((item) => item.status === PaymentProviderStatuses.connected)?.id,
);

export const isConnectedPaymentProviderSelector = selector(paymentProvidersSelector, (p) =>
  p.some((item) => item.status === PaymentProviderStatuses.connected),
);

export const hasConnectedPaymentProviderSelector = selector(
  paymentProvidersSelector,
  (p) => !p.isEmpty() && p.some((provider) => provider.get('status') === PaymentProviderStatuses.connected),
);

export const isProvidersLoadedSelector = selector(paySettings, (p) => p.isProvidersLoaded);

export const providerApproversSelector = selector(paySettings, (p) => p.approvers);

export const shouldRenewProviderApprovers = (companyId) =>
  selector(
    providerApproversSelector,
    isStoreOnAnotherCompany(companyId),
    (approvers, isAnotherCompany) => !approvers.size || isAnotherCompany,
  );

// By the loaded flag, not the list size: a loaded empty list (the backend returned only removed providers, DPM-846)
// stays cached. The flag is reset on entering another company and while a request is in flight.
export const shouldRenewPaymentProviders = selector(isProvidersLoadedSelector, (isLoaded) => !isLoaded);
